// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9910 ? "a4634e51" : chunkId) + "." + {"995":"35d70fbcf3d5cc48","4988":"bf1fa75a7901f22b","9910":"ad5aa725a0508f87"}[chunkId] + ".js";
};